import { Knot } from './Knot';
import {
  NAV_DESTINATIONS,
  KNOT_SLOT_INDEX,
  navHref,
  isGoldTab,
  type NavModelProps,
  type NavDestination,
} from './navModel';
import type { TopTab } from '../routes/route';
import './BottomNav.css';

// R1a: kept as a named re-export so existing importers (App, tests) that
// referenced BottomNavProps keep compiling — it's now the shared nav model.
export type BottomNavProps = NavModelProps;

// The locked PHONE shell: Today · Auditions · [Knot, raised, centred] ·
// Projects · Career. The Knot is present on every screen, breathing at idle,
// and is THE capture action from anywhere. Career is a distinct "mode" — when
// active it highlights GOLD rather than the ordinary active colour every
// other tab uses; nothing else in this bar ever takes that colour.
//
// Destinations, active state and the gold rule all come from ../navModel —
// the SAME model the SideRail renders on tablet/desktop. This bar only owns
// the horizontal, split-around-the-Knot layout.
export function BottomNav({ active, onNavigate, knotState, onKnotPress }: BottomNavProps) {
  const left = NAV_DESTINATIONS.slice(0, KNOT_SLOT_INDEX);
  const right = NAV_DESTINATIONS.slice(KNOT_SLOT_INDEX);
  return (
    <nav class="bottom-nav" aria-label="Primary">
      {left.map((item) => (
        <NavItem key={item.tab} item={item} active={active === item.tab} onNavigate={onNavigate} />
      ))}
      <div class="bottom-nav__knot-slot">
        <button type="button" class="bottom-nav__knot-btn" aria-label="Knot" onClick={onKnotPress}>
          <Knot state={knotState} />
        </button>
      </div>
      {right.map((item) => (
        <NavItem key={item.tab} item={item} active={active === item.tab} onNavigate={onNavigate} />
      ))}
    </nav>
  );
}

function NavItem({
  item,
  active,
  onNavigate,
}: {
  item: NavDestination;
  active: boolean;
  onNavigate: (tab: TopTab) => void;
}) {
  const classes = ['bottom-nav__item'];
  if (active) classes.push(isGoldTab(item.tab) ? 'bottom-nav__item--gold' : 'bottom-nav__item--active');

  return (
    <a
      class={classes.join(' ')}
      href={navHref(item.tab)}
      aria-current={active ? 'page' : undefined}
      onClick={(e) => {
        e.preventDefault();
        onNavigate(item.tab);
      }}
    >
      <span class="bottom-nav__dot" />
      {item.short}
    </a>
  );
}
